import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './locales/en';
import koTranslation from './locales/ko';
import jaTranslation from './locales/ja';
import esTranslation from './locales/es';

const resources = {
  en: {
    translation: enTranslation
  },
  ko: {
    translation: koTranslation
  },
  ja: {
    translation: jaTranslation
  },
  es: {
    translation: esTranslation
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || navigator.language.split('-')[0] || 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
